// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"hK-z","carouselContainer":"iK-z"};